import React from 'react';
import { Link } from 'carbon-components-react';

const Guideline: React.FC<Props> = ({ type }) => {
  return (
    <>
      {type === 'canCreateNewEnquiry' ? (
        <>
          <p>
            You’re probably not seeing any of your BYDA enquiries on the map
            yet.
          </p>
          <p>
            To get the most from SmarterWX Locate, first submit a new enquiry.
          </p>
        </>
      ) : (
        <>
          <p>
            You’re probably not seeing any of your BYDA enquiries on the map
            yet.
          </p>
          <p>
            To get the most from SmarterWX Locate, first submit a new enquiry in{' '}
            <Link
              onClick={() =>
                window.open(process.env.REACT_APP_SENTINEL_WEB_URL, '_blank')
              }
            >
              Before You Dig Australia
            </Link>
            .
          </p>
        </>
      )}
    </>
  );
};

type Props = {
  type: string;
};

export default React.memo(Guideline);
